<template lang="html">
<span class="charcount">
  <span class="min-msg vermelho-1" v-if="showMinMsg">Mínimo de {{min}} caracteres</span>
  <span v-if="showMinMsg"> | </span>
  <span class="charcount-prefix">{{prefix}}</span>
  <span class="charcount-value">{{charcountval}}</span>
  <span class="charcount-suffix">{{suffix}}</span>
</span>
</template>

<script>
export default {
  name: 'CharCount',
  props: {
    dataString: {
      type: String,
      required: true,
      default: ''
    },
    prefix: {
      type: String
    },
    suffix: {
      type: String
    },
    countdown: {
      type: Number
    },
    min: {
      type: Number
    }
  },
  computed: {
    charcountval () {
      if (this.countdown) {
        return this.countdown - this.dataString.length
      } else {
        return this.dataString.length
      }
    },
    showMinMsg () {
      if (this.dataString.length < this.min) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss">
.charcount {
  .vermelho-1 {
    color: #f00
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CharCount.vue